var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRemove(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 36.4 36.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#999",
    d: "M21.2 18.2L35.8 3.6c.8-.8.8-2.1 0-3-.8-.8-2.1-.8-3 0L18.2 15.2 3.6.6c-.8-.8-2.1-.8-3 0-.8.8-.8 2.1 0 3l14.6 14.6L.6 32.8c-.8.8-.8 2.1 0 3 .4.4 1 .6 1.5.6s1.1-.2 1.5-.6l14.6-14.6 14.6 14.6c.4.4.9.6 1.5.6.5 0 1.1-.2 1.5-.6.8-.8.8-2.1 0-3L21.2 18.2z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemove);
export default __webpack_public_path__ + "static/media/remove.4f56fbf438c2d17f2fd3f2e7cae685f2.svg";
export { ForwardRef as ReactComponent };